import { Navigate, useLocation } from "react-router-dom";
import React, { useContext } from "react";

import { AppRoutes } from "../../constants/appRoutes";
import { AuthContext } from "../../context/contextProvider";
import BuildIcon from "@mui/icons-material/Build";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ServiceOrdersPage from "./ServiceOrdersPage";

const breadcrumbs = [
  {
    IconComponent: DashboardIcon,
    title: "Dashhboard",
    to: AppRoutes.dashboard,
  },
  {
    IconComponent: BuildIcon,
    title: "Service Orders",
  },
];

const ServiceOrdersActivePage = (props) => {
  const { state } = useLocation();
  const { branchModules } = useContext(AuthContext);

  if (!branchModules?.serviceOrders)
    return (
      <Navigate
        to={{
          pathname: AppRoutes.forbidden,
        }}
      />
    );

  return (
    <ServiceOrdersPage
      breadcrumbs={breadcrumbs}
      dashboardType={state?.dashboardType}
      title="Service Orders - Active"
    />
  );
};

export default ServiceOrdersActivePage;
